// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-grid {
  height: 100%;
}

ion-row:first-of-type {
  display: flex;
  align-items: center;
  min-height: 80%;
}

ion-row {
  min-height: 20%;
}

ion-icon {
  font-size: 45px;
}

.bottom-spacer {
  margin-bottom: 50px;
}

p {
  font-size: 20px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/success-error-report-modal/success-error-report-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,eAAA;AACF","sourcesContent":["ion-grid {\n  height: 100%;\n}\n\nion-row:first-of-type {\n  display: flex;\n  align-items: center;\n  min-height: 80%;\n}\n\nion-row {\n  min-height: 20%;\n}\n\nion-icon {\n  font-size: 45px;\n}\n\n.bottom-spacer {\n  margin-bottom: 50px;\n}\n\np {\n  font-size: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
